// extracted by mini-css-extract-plugin
export default {"legend":"heropic_legend__Z9N5b"};